import { setSpecificMessage, maxLength } from "valibot";
setSpecificMessage(
  maxLength,
  (issue) => `Longeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);